import * as api from '../../api/index'
import * as endpoints from '../../api/endpoints'
import * as types from "../../mutation-types";

const actions = {
    getParcels({commit}, payload) {
        return api.fetch(endpoints.PARCELS, payload, commit,(response) => {
          commit(types.SET_PARCELS, response.data.data);
          commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
        });
    },
    getParcel({commit}, payload) {
      return api.fetch(endpoints.PARCELS+'/'+payload.uuid, payload, commit,(response) => {
        commit(types.SET_PARCEL, response.data);
      });
    },
    getParcelGroups({commit}, payload) {
        if (!payload) {
            payload = {};
        }

      payload.is_group = 1;
      payload.venablePagination = 0;
      payload.limit = 9999;
      return api.fetch(endpoints.PARCELS, payload, commit,(response) => {
        commit(types.SET_PARCEL_GROUPS, response.data.data);
      });
    },
    createParcel({commit}, payload) {
      return api.post(endpoints.PARCELS, payload,  commit,(response) => {
        commit(types.SET_PARCEL, response.data);
      });
    },
    updateParcel({commit}, payload) {
      return api.put(endpoints.PARCELS+'/'+payload.uuid, payload, commit, (response) => {
        commit(types.SET_PARCEL, response.data);
      })
    },
    deleteParcel({commit}, payload) {
      return api.remove(endpoints.PARCELS+'/'+payload.uuid, payload,  commit,(response) => {
        commit(types.SET_PARCEL, response.data);
      })
    },
    changeParcelsCulture({commit}, payload) {
        return api.put(endpoints.CHANGE_PARCELS_CULTURE, payload, commit, (response) => {
            commit(types.SET_PARCEL_SET, response.data);
        })
    },
    changeParcelsGroup({commit}, payload) {
        return api.put(endpoints.CHANGE_PARCELS_GROUP, payload, commit, (response) => {
            commit(types.SET_PARCEL_SET, response.data);
        })
    },
    parcelsCopy({commit}, payload) {
        return api.post(endpoints.PARCELS_COPY, payload, commit, (response) => {
        })
    },
    getCropRotation({commit}, payload) {
        return api.fetch(endpoints.PARCELS_CROP_ROTATION, payload, commit, (response) => {
        })
    },
    getHarvestedSurfaceReport({commit}, payload) {
        return api.fetch(endpoints.PARCELS_HARVESTED_SURFACE, payload, commit, (response) => {
        })
    },
    getSowedSurfaceReport({commit}, payload) {
        return api.fetch(endpoints.PARCELS_SOWED_SURFACE, payload, commit, (response) => {
        })
    },
}

export default actions;
